import { Component } from '@angular/core';

@Component({
  selector: 'app-lite-flow-tournament',
  imports: [],
  templateUrl: './lite-flow-tournament.html',
  styleUrl: './lite-flow-tournament.css',
})
export class LiteFlowTournament {}
